import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ResumeErrorService {
  private readonly errorSource = new Subject<void>();
  readonly error$ = this.errorSource.asObservable();

  show(): void {
    this.errorSource.next();
  }
}
